import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";

//bi fetched
export const fetchIIbCount = (payload) => {
  // console.log("payload", payload);
  return {
    type: actionTypes.IIBCOUNT,
    formData: payload,
  };
};

export const fetchIIbResponse = (payload) => {
  return async (dispatch) => {
    try {
      if (!payload?.proposal_id) {
        console.warn("fetchIIbResponse: Missing proposal_id in payload");
        return null;
      }
      // payload: { proposal_id: string }
      const response = await axiosRequest.post("user/iibResponse", payload
      // {
      //   secure: true,
      // }
      );
      console.log("IIB Response API Result:", response);     
      // dispatch(fetchIIbCount(response));
      return response;
    } catch (error) {
      console.error("Error in fetchIIbResponse:", error);
      // Return null or empty to prevent blocking the flow
      return null;
    }
  };
};

export const iibPolicyReasons = (payload) => {
  return async (dispatch) => {
    try {
      /*
      payload: {
        policyId: string,
        previousPolicyReasons: [
          {
            QuestDBNo: string,
            QuestPolicyStatus: string,
            QuestReason: string
          }
        ]
      }
      */
      const response = await axiosRequest.post("user/iibPolicyReasons", payload);
      console.log("Save IIB Reasons API Result:", response);
      return response;
    } catch (error) {
      console.error("Error in iibPolicyReasons:", error);
      return null;
    }
  };
};
